// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_81de1d3","returns":"_34bd822","description":"_7ff98d2","value":"_c928cf2","bonusCash":"_627ee2e","returnValue":"_ddb4920","returnValuePriceChange":"_77283ac"};